import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=ac300ffc&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ac300ffc",
  null
  ,true
)

export default component.exports